module.exports = global["PIXI"] = require("-!./pixi.js");


//////////////////
// WEBPACK FOOTER
// ./~/phaser-ce/build/custom/pixi.js
// module id = 523
// module chunks = 3